"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateReceivableReport = void 0;
/* eslint-disable no-param-reassign */
const common_1 = require("@finley-technologies/common");
const updateReceivableReport = ({ receivableReport, receivable, borrowingBaseReportForLatestApprovedFundingRequestMetadata, }) => {
    receivableReport.assetValuation += receivable.valuationFields.valuation;
    receivableReport.totalPerformingExposure +=
        receivable.postProcessedFields.performingExposure ?? 0;
    // Get current state of basic report
    const basicReport = receivableReport.basicReport;
    // *** Receivable calculations ***
    const totalReceivableExposure = basicReport.totalReceivableExposure +
        receivable.requiredIntermediateFields.exposure;
    // all receivables should be assigned.
    // if there's no latest approved funding request, or the current receivable was assigned after the
    // reporting date and file version of the borrowing base report of the latest approved funding request
    // then the receivable's eligible exposure should contribute to the newlyAssignedEligibleExposure
    const isNewlyAssignedReceivable = receivable.assignmentFields &&
        (!borrowingBaseReportForLatestApprovedFundingRequestMetadata ||
            receivable.assignmentFields.reportingDate >
                borrowingBaseReportForLatestApprovedFundingRequestMetadata.reportingDate ||
            (receivable.assignmentFields.reportingDate ===
                borrowingBaseReportForLatestApprovedFundingRequestMetadata.reportingDate &&
                receivable.assignmentFields.fileVersion >
                    borrowingBaseReportForLatestApprovedFundingRequestMetadata.fileVersion));
    receivableReport.assignedEligibleExposureSinceLastApprovedFundingRequest += isNewlyAssignedReceivable
        ? receivable.eligibilityFields.eligibleExposure
        : 0;
    const totalEligibleExposure = basicReport.totalEligibleExposure +
        receivable.eligibilityFields.eligibleExposure;
    const eligibleExposureLessConcentrationKickouts = basicReport.borrowingBaseAmountAssets +
        receivable.concentrationLimitFields
            .eligibleExposureLessConcentrationLimitKickouts;
    const borrowingBaseAmount = basicReport.maxReceivableAdvanceAmount +
        receivable.borrowingBaseFields.borrowingBaseAmount;
    // *** Aggregate calculations (uses results from above) ***
    const totalEligibilityKickout = totalReceivableExposure - totalEligibleExposure;
    const totalConcentrationKickout = totalEligibleExposure - eligibleExposureLessConcentrationKickouts;
    receivableReport.effectiveReceivableValuationRate = common_1.utils.divideByOrZero(receivableReport.assetValuation, totalReceivableExposure);
    receivableReport.effectiveReceivableAdvanceRate = common_1.utils.divideByOrZero(borrowingBaseAmount, totalReceivableExposure);
    receivableReport.weightedAverageReceivableAdvanceRate = common_1.utils.divideByOrZero(borrowingBaseAmount, eligibleExposureLessConcentrationKickouts);
    // Explicitly setting all properties in this format to avoid missing any properties with direct param reassignment on each line above
    receivableReport.basicReport = {
        id: basicReport.id,
        borrowingBaseAmountAssets: eligibleExposureLessConcentrationKickouts, // Legacy naming
        maxReceivableAdvanceAmount: borrowingBaseAmount, // Legacy naming
        totalConcentrationKickout,
        totalEligibilityKickout,
        totalEligibleExposure,
        totalReceivableExposure,
    };
};
exports.updateReceivableReport = updateReceivableReport;
//# sourceMappingURL=receivableReport.js.map